import { Reveal } from "@/components/site/reveal";

export type FaqItem = { q: string; a: string };

export function FaqList({ items }: { items: readonly FaqItem[] }) {
  return (
    <ul className="mt-14 grid gap-5 md:grid-cols-2">
      {items.map((item, i) => (
        <Reveal as="li" key={item.q} delay={(i % 2) * 80}>
          <div className="h-full rounded-3xl border border-border/70 bg-card p-6 shadow-[var(--shadow-soft)]">
            <h3 className="font-display text-lg leading-snug">{item.q}</h3>
            <p className="mt-2.5 text-sm leading-relaxed text-muted-foreground">{item.a}</p>
          </div>
        </Reveal>
      ))}
    </ul>
  );
}

export function faqJsonLd(items: readonly FaqItem[]) {
  return {
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };
}
